import { CUSTOMER_MESSAGES } from '../../../../constants/customerMessages'

export const NEW_REZ_PHONE_NUMBER = '(855) 923-1054'
export const NEW_REZ_DTC_CUSTOMER_PROFILE_ID = 'f2190c10-8853-4d93-8b31-2fb0fe4eda5d'
export const NEW_REZ_UPDATED_DM_NOTIFICATION_TOPIC_KEYS = [
  CUSTOMER_MESSAGES.HOMEOWNER_MARKET.topicKey,
  CUSTOMER_MESSAGES.SHOULD_SELL_MARKET.topicKey,
  CUSTOMER_MESSAGES.HOME_APPRECIATION.topicKey,
  CUSTOMER_MESSAGES.IF_THEY_SHOULD_SELL.topicKey,
  CUSTOMER_MESSAGES.USING_EQUITY.topicKey,
  CUSTOMER_MESSAGES.PURCHASING_POWER.topicKey,
  CUSTOMER_MESSAGES.HOME_VALUE.topicKey
]
export const NEW_REZ_COMPANY_ID = 'f6730666-cd94-4e1a-b300-de1e370ba15d'
